// The durations a service offers, read the way the rest of the product reads
// them.
//
// A service carries `durationOptions` as LABELS ("45 min", "1 hour") and
// `defaultDuration` as one more label. Both are strings, and the engine wants
// whole minutes, so parsing happens here rather than in three components.
//
// Copied from `blhClinicApp/src/utils/commercialLinePricing.js`
// (`parseDurationMinutes`) and `features/waitlist/components/waitlistEntryForm.js`
// (`durationChoices`) so the portal offers the SAME choices the front desk
// does. Two different answers to "how long is this appointment" is how a
// patient books 45 minutes that the clinic never sells.

const MAX_DURATION_MINUTES = 8 * 60;

/** "45 min" -> 45. The label's leading integer is the whole of the answer. */
export function parseDurationMinutes(durationLabel, fallbackMinutes = 45) {
  if (typeof durationLabel !== "string" || durationLabel.trim().length === 0) {
    return fallbackMinutes;
  }
  const parsed = Number.parseInt(durationLabel.split(" ")[0], 10);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : fallbackMinutes;
}

/** "90" -> "1 h 30 min", for a picker whose values are integers. */
export function formatMinutes(value) {
  if (!Number.isInteger(value) || value <= 0) return "";
  const hours = Math.floor(value / 60);
  const minutes = value % 60;
  if (hours === 0) return `${minutes} min`;
  if (minutes === 0) return `${hours} h`;
  return `${hours} h ${minutes} min`;
}

/**
 * @returns {{options: number[], defaultMinutes: number}} sorted, deduplicated
 */
export function durationChoices(service) {
  const labels = Array.isArray(service?.durationOptions)
    ? service.durationOptions
    : [];
  const defaultMinutes = parseDurationMinutes(service?.defaultDuration);
  const minutes = new Set([defaultMinutes]);
  labels.forEach((label) => {
    const parsed = parseDurationMinutes(label, 0);
    if (parsed > 0 && parsed <= MAX_DURATION_MINUTES) minutes.add(parsed);
  });
  return {
    options: [...minutes].sort((a, b) => a - b),
    defaultMinutes,
  };
}
